import { render, staticRenderFns } from "./NodeShareModal.vue?vue&type=template&id=6079550a&scoped=true"
import script from "./NodeShareModal.vue?vue&type=script&lang=ts"
export * from "./NodeShareModal.vue?vue&type=script&lang=ts"
import style0 from "./NodeShareModal.vue?vue&type=style&index=0&id=6079550a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6079550a",
  null
  
)

export default component.exports